var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardBody',[_c('h5',{staticClass:"text-primary"},[_vm._v("Speciality")]),_c('div',[_c('GPie',{attrs:{"data":_vm.specialityChartData,"keys":_vm.keys}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }